import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

export const BackButton = ({ onClick }) => {
  const { t } = useTranslation();
  
  return (
    <button 
      className="ct-mobile-menu__list-elem ct-mobile-menu__back-button" 
      onClick={onClick}
      aria-label={t('back')}
      tabIndex="0"
      data-e2e="mobile-menu-back-button"
    >
      <FontAwesomeIcon icon={faAngleLeft} aria-hidden="true" /> {t('back')}
    </button>
  );
};
